import React from 'react';

import Guest from 'app/components/icons/Guest';
import ReservationDetail, {
  ReservationDetailProps,
} from 'app/components/ReservationSummary/ReservationDetail';
import TextLabel from 'app/components/ReservationSummary/TextLabel';
import { useI18n } from 'app/providers/I18nProvider';
import { Pass, TicketClass } from 'app/services/GuestCenterService.types';
import { tID } from 'app/services/TestHelper';

export type ReservationDetailTravelPartyProps = Omit<ReservationDetailProps, 'Icon'> & {
  passes: Pass[];
  addOnsQuantity?: number;
};

function ReservationDetailTravelParty({
  passes = [],
  addOnsQuantity = 0,
  ...props
}: ReservationDetailTravelPartyProps) {
  const { t } = useI18n();
  const qty = passes.reduce<Record<TicketClass, number>>(
    (prev, pass) => {
      /* eslint-disable no-param-reassign */
      prev[pass.ticketClass] += 1;
      /* eslint-enable no-param-reassign */
      return prev;
    },
    {
      [TicketClass.Adult]: 0,
      [TicketClass.Child]: 0,
    }
  );

  const childCount = qty.Child + addOnsQuantity;
  const totalCount = qty.Adult + childCount;

  return (
    <ReservationDetail Icon={Guest} testID={tID('ReservationDetailTravelParty')} {...props}>
      <TextLabel>{totalCount > 0 && `Party (${totalCount})`}</TextLabel>
    </ReservationDetail>
  );
}

ReservationDetailTravelParty.Icon = Guest;

export default ReservationDetailTravelParty;
